import { Space, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined } from "@ant-design/icons";
import ModalItem from "./ModalItem";
import ButtonItem from "./ButtonItem";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import polizaPdf from "../Pdf/polizaPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalPdfPoliza extends Component {
  iframeRef = React.createRef();
  state = {
    loading: false,
    pdf: null,
    numeroPoliza: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      if (this.props.visible && this.props.polizaId) {
        this.consultarDatosPdf();
      } else if (!this.props.visible) {
        // Limpiar para que al reabrir con otra póliza siempre se re-consulte
        this.setState({ pdf: null, numeroPoliza: null });
      }
    }
  }

  consultarDatosPdf() {
    this.setState({ loading: true });
    axios
      .post(
        "polizas/datosPoliza",
        { polizaId: this.props.polizaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (!res.data || res.data === "error" || res.data.status === 404 || !res.data.poliza) {
          message.error("No se encontró la póliza");
          this.setState({ loading: false });
          return;
        }
        const pdf = pdfMake.createPdf(polizaPdf(res.data));
        this.setState(
          {
            loading: false,
            pdf: pdf,
            numeroPoliza: res.data.poliza.numeroTipoPoliza,
          },
          () => this.abrirEnIframe(pdf)
        );
      })
      .catch(() => {
        message.error("Hubo un error y no se pudo generar el PDF de la póliza");
        this.setState({ loading: false });
      });
  }

  abrirEnIframe(pdf, intento = 0) {
    const frame =
      this.iframeRef.current?.contentWindow || window.frames["PolizaPdfIframeModal"];
    if (frame) {
      pdf.open({}, frame);
      return;
    }
    if (intento < 10) {
      setTimeout(() => this.abrirEnIframe(pdf, intento + 1), 100);
    }
  }

  descargarPdf() {
    if (this.state.pdf) {
      this.state.pdf.download(`Poliza_${this.state.numeroPoliza || "Documento"}.pdf`);
    }
  }

  handleCancel = () => {
    this.props.onCancel();
  };

  render() {
    return (
      <ModalItem
        title="Póliza"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.handleCancel}
        paddingTop
        width={800}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
          <Space>
            <ButtonItem
              icon={<DownloadOutlined />}
              type="primary"
              lessTime
              disabled={!this.state.pdf}
              onClick={() => this.descargarPdf()}
            >
              Descargar PDF
            </ButtonItem>
            <ButtonItem danger lessTime onClick={this.handleCancel}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>
        <iframe
          ref={this.iframeRef}
          title={"Poliza PDF"}
          style={{ width: "100%", height: "75vh", border: "1px solid #d9d9d9" }}
          id="PolizaPdfIframeModal"
          name="PolizaPdfIframeModal"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalPdfPoliza);
